<template>
  <el-container>
    <el-main>
      <h3 class="heading">New integration format</h3>
      <el-card>
        <IntegrationForm
          v-if="feedFormatItem"
          v-model="feedFormatItem"
          :loading="loading"
          action-text="Create"
          @submit="onSubmit"
        />
      </el-card>
      <LoadingBlock :loading="fetchingFeedFormat" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, InjectionKey, provide, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import {
  AdType,
  FeedFormatValidationErrorsKey,
  ProtocolType
} from '@/api/types'
import {
  IFeedFormat,
  IFeedFormatAttributes
} from '@/apps/traforama/interfaces/feedFormats'

import useRouter from '@/hooks/useRouter'
import { useFeedFormatsStore } from '@/apps/traforama/store/feedFormats'
import IntegrationForm from '../components/IntegrationForm.vue'
import useValidation from '@/hooks/useValidation'
import useFetchFeedFormat from '@/hooks/useFetchFeedFormat'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { safeSubmitProcessing } from '@/utils/helpers'

export default defineComponent({
  name: 'NewFeedFormat',
  components: {
    IntegrationForm,
    LoadingBlock
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    feedId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const feedFormatsStore = useFeedFormatsStore()
    let fetchingFeedFormat = false
    let feedFormatItem = ref<IFeedFormatAttributes | undefined>({
      id: undefined,
      name: '',
      type_ids: AdType.Popunder,
      type: ProtocolType.Xml,
      rate_xpath: '',
      feed_id: props.feedId ? Number(props.feedId) : undefined,
      rate_in_cpm: false,
      url_xpath: '',
      title_xpath: '',
      icon_xpath: '',
      image_xpath: '',
      description_xpath: '',
      win_notify_url_xpath: '',
      impression_url_xpath: '',
      response_sample: ''
    })
    if (props.id) {
      let { feedFormat, FetchItem } = useFetchFeedFormat()
      FetchItem(props.id, true)
      feedFormatItem.value = feedFormat
    }
    const { provideValidation, setValidationErrors } = useValidation(
      FeedFormatValidationErrorsKey
    )
    const errors = provideValidation()

    const loading = ref(false)

    const { router } = useRouter()

    const onSuccess = async () => {
      const route = props.feedId
        ? `/feeds/edit/${props.feedId}`
        : '/integrations'
      await router.push(route)
      ElMessage.success({ message: 'Integration format has been created' })
    }

    const onSubmit = async ({
      feedFormat,
      withReview
    }: {
      feedFormat: IFeedFormatAttributes
      withReview: boolean
    }) => {
      await safeSubmitProcessing(
        loading,
        () => feedFormatsStore.SaveItem(feedFormat),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    return { feedFormatItem, errors, loading, onSubmit, fetchingFeedFormat }
  }
})
</script>
